import * as React from 'react';

import { TableCell, TableHead, TableRow } from '@mui/material';

const className = 'px-2 py-1 uppercase font-bold bg-blue-100 border-blue-300';

export const ColumnMappingHeader: React.FC = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell className={className} width={176}>
          <h6>Column Header From File</h6>
        </TableCell>
        <TableCell className={className}>
          <h6>Data Preview (First Row)</h6>
        </TableCell>
        <TableCell className={`border-l-0 ${className}`} width={124}>
          <h6>Mapped</h6>
        </TableCell>
        <TableCell className={`border-l-0 border-r ${className}`} width={176}>
          <h6>BlueCargo Property</h6>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
ColumnMappingHeader.displayName = 'ColumnMappingHeader';
